function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="16" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.22.272l1.508 1.508a.926.926 0 0 1 0 1.311l-12.15 12.15a.926.926 0 0 1-1.31 0L.272 9.245a.926.926 0 0 1 0-1.311L1.78 6.426a.926.926 0 0 1 1.31 0l3.832 3.83L16.909.27a.929.929 0 0 1 1.311.002z" fill="#278C7E" /></svg>;
});